import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_LCM_PETITION_SIGNER_RECEIPT_WELCOME_CONFIG = createFcmDetails(
	'lcm_petition_signer_receipt_welcome_config',
	{
		owner: 'Site Platform',
		context: 'comms stack',
		import: false,
		description:
			'LCM config for petition_signer_receipt_welcome message. Defines which country codes route petition_signer_receipt_welcome messages to Iterable',
		template: {
			constraints: ['AR', 'AU', 'BR', 'CA', 'DE', 'ES', 'FR', 'GB', 'ID', 'IN', 'IT', 'JP', 'MX', 'TH', 'TR', 'US'],
		},
	},
);
